const translations = {
  "en": {
    " invites you to join Aura": " invites you to join Points",
    "Let's get your Aura flowing, sharpen Edgen's brain, climb that leaderboard, and stack up serious rewards.": "Let's get your Points flowing, sharpen Ed's brain, climb that leaderboard, and stack up serious rewards.",
    "Welcome Back, Aura Champion": "Welcome Back, Points Champion",
    "You've been chosen. Time to turn those insights into pure power.": "You've been chosen. Time to turn those insights into pure power."
  },
  "zh-tw": {
    " invites you to join Aura": "邀請你加入 Points",
    "Let's get your Aura flowing, sharpen Edgen's brain, climb that leaderboard, and stack up serious rewards.": "讓我們開始賺取 Points，磨礪 Ed 的智慧，登上排行榜，並獲得豐厚獎勵。",
    "Welcome Back, Aura Champion": "歡迎回來，Points 冠軍",
    "You've been chosen. Time to turn those insights into pure power.": "你已被選中。是時候將這些洞察轉化為純粹的動力了。"
  }
};

export default translations;
